module.exports = __webpack_public_path__ + "img/text-survey.2b4713cc.png";